// src/main.tsx
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import rootRouter from "./routes/app.router";
import { Provider } from "react-redux";
import { persistor, store } from "./store";
import { PersistGate } from "redux-persist/integration/react";
import { ThemeProvider } from "@mui/material";
import theme from "./themes/app.theme";
import { PortalProvider } from "./contexts/PortalContainerContext";
import { LicenseInfo } from "@mui/x-license";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./lib/react-query";
import { ConfirmProvider } from "material-ui-confirm"; // Importa el ConfirmProvider
import { SnackbarProvider } from "notistack"; // Opcional: si usas notistack

LicenseInfo.setLicenseKey(
  "e0d9bb8070ce0054c9d9ecb6e82cb58fTz0wLEU9MzI0NzIxNDQwMDAwMDAsUz1wcmVtaXVtLExNPXBlcnBldHVhbCxLVj0y"
);

createRoot(document.getElementById("root")!).render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <ConfirmProvider // Agrega el ConfirmProvider aquí
            defaultOptions={{
              confirmationButtonProps: {
                autoFocus: true,
                variant: "contained",
                color: "error",
              },
              cancellationButtonProps: { variant: "outlined" },
              dialogProps: { maxWidth: "xs" },
            }}
          >
            <SnackbarProvider maxSnack={3}>
              {" "}
              {/* Opcional: si usas notistack */}
              <PortalProvider>
                <RouterProvider router={rootRouter} />
              </PortalProvider>
            </SnackbarProvider>
          </ConfirmProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </PersistGate>
  </Provider>
);
